"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateNewTag() {
    return Math.random().toString();
}
exports.generateNewTag = generateNewTag;
//# sourceMappingURL=generateNewTag.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/datalayerHelpers/generateNewTag.js
// module id = 55
// module chunks = 0